import { render, staticRenderFns } from "./LayoutToolbar.vue?vue&type=template&id=3838f476&scoped=true"
import script from "./LayoutToolbar.vue?vue&type=script&lang=js"
export * from "./LayoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./LayoutToolbar.vue?vue&type=style&index=0&id=3838f476&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838f476",
  null
  
)

export default component.exports